import * as axios from 'axios';
import { API } from '../config/config';

const postVerifyOtp = async function (captcha, code, number, id) {
	try {
		const response = await axios.post(`${API}/otp/VerifyOtp?code=${code}&number=${number}&id=${id}`);
		return response;
	} catch (err) {
		throw new Error(err)
	}
};

const postGenerateOtp = async function (captcha, phoneNumber) {
	try {
		const response = await axios.post(`${API}/otp/generateOtp?phoneNumber=${phoneNumber}`);
		return response;
	} catch (err) {
		throw new Error(err)
	}
};

export const otpService = {
	postVerifyOtp,
	postGenerateOtp,
};
